// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"35687": "92b62289","43812": "a9ba83a5","60630": "83812526","67049": "6a81d06e",}[chunkId] + ".css"
}